export class ApiError extends Error {
    code?: number;
    constructor(message: string, code?: number) {
        super(message);
        this.code = code;
        Object.setPrototypeOf(this, new.target.prototype); // Restore prototype chain
    }
}